import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
  Row,
} from "react-bootstrap";
import { RxHamburgerMenu } from "react-icons/rx";
import { GetCompanyDetails } from "../../APICalls";
import toast from "react-hot-toast";
import { Router, useNavigate } from "react-router-dom";

function AdminLayout({ children, pageName }) {
  const [show, setShow] = useState(false);

  const [logo, setLogo] = useState(null);
  const [brandLogo, setBrandLogo] = useState(null);

  const [name, setName] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Api_url = "https://broker.accountiez.com/client/profiles/company/";

  

  const fetchCompanyDetails = async () => {
    const data = await GetCompanyDetails();

    if (data.error) {
      toast.error("Failed to Fetch Company Details");
      return;
    }
    setLogo(data.logo);
    setName(data.name);
  };

  useEffect(() => {
    // fetchCompanyDetails()
  }, [])

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await axios.get(Api_url, {
          headers: { "Content-Type": "application/json" },
        });
        setLogo(response.data.logo);
        setName(response.data.name);
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };
    // fetchLogo();
    fetchCompanyDetails()
  }, []);

  const Api = "https://broker.accountiez.com/client/profiles/brand/";

  useEffect(() => {
    const fetchdata = async () => {
      try {
        let response = await axios.get(Api, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("responseeeeeeeeee", response);
        setBrandLogo(response.data.logo);
      } catch (error) {
        console.error(error);
      }
    };

    fetchdata();
  }, []);

  const ExhibitionDropdown = () => (
    <NavDropdown
      title="EXHIBITION FORM"
      id="exhibition-dropdown"
      className="mt-2"
    >
      <NavDropdown.Item href="/createcustomer">
        • CREATE CUSTOMER
      </NavDropdown.Item>
      <NavDropdown.Item href="/editCustomer">• EDIT CUSTOMER</NavDropdown.Item>
      <NavDropdown.Item href="/orderentryform">
        • ORDER ENTRY FORM
      </NavDropdown.Item>
      <NavDropdown.Item href="/orderformprint">
        • ORDER FORM PRINT
      </NavDropdown.Item>
      <NavDropdown.Item href="/totalorderssummary">
        • TOTAL ORDERS SUMMARY
      </NavDropdown.Item>
            <NavDropdown.Item href="/total-customers">
        • TOTAL CUSTOMERS
      </NavDropdown.Item>
    </NavDropdown>
  );

  return (
    <div>
      {pageName != "login" &&
        <Navbar bg="light" variant="dark" expand="lg" className="px-3 fixed-top ">
          <>
            <Row className=" w-100 align-items-center justify-content-between ">
              <Col xs={5} className="">
                <div className="d-flex align-items-center ">
                  <Navbar.Brand className=" p-0">
                    <div className="logo-container">
                      {logo && <img src={logo} alt="Company Logo"
                        style={{ objectFit: (name.includes("Modi") || name==="Accountiez") ? 'contain' : 'cover' }}
                      />}
                    </div>
                  </Navbar.Brand>
                  <Navbar.Brand
                    style={{
                      color: "#23395B",
                      fontFamily: "Roboto",
                      fontWeight: "600",
                      marginRight: "auto",
                      fontSize: "17px",
                      opacity:0,
                    }}
                  >
                    {name}
                  </Navbar.Brand>
                </div>
              </Col>
              <Col xs={9} sm={5} md={6} className="">
                <Navbar.Brand
                  className=""
                  style={{
                    color: "#23395B",
                    fontFamily: "Roboto",
                    fontWeight: "600",
                    // marginRight: "auto",
                    fontSize: "25px",
                  }}
                >
                  {" "}
                  {pageName}
                </Navbar.Brand>
              </Col>

              <Col xs={1} sm={1} className="">
                <Button
                  style={{ marginLeft: "auto" }}
                  variant="outline-light"
                  className="d-lg-none "
                  onClick={handleShow}
                >
                  <RxHamburgerMenu
                    style={{
                      width: "30px",
                      height: "30px",
                      cursor: "pointer",
                      color: "#000",
                      textAlign: "right",
                    }}
                  />
                </Button>
              </Col>
            </Row>
          </>
        </Navbar>
      }
      {/* Sidebar for Large Screens */}
      {pageName != 'login' &&
        <>

          <div className="sidebar d-none d-lg-block">
            <Nav className="flex-column p-3">
              <Nav.Link href="/admin-dashboard" className="active">
                CUSTOMER RESTRICTION DETAIL
              </Nav.Link>
              {/* <Nav.Link href="/stock-list">STOCK LIST</Nav.Link> */}
              <Nav.Link href="/addtocartsummary">ADD TO CART SUMMARY</Nav.Link>
              <div className="d-none d-lg-block">
                <ExhibitionDropdown />
              </div>{" "}
            </Nav>
          </div>
          {/* Offcanvas Sidebar for Mobile and Tablets */}
          <Offcanvas
            style={{ marginTop: "7%" }}
            className="two"
            show={show}
            onHide={handleClose}
            responsive="lg"
          >
            <Offcanvas.Header
              className="custom-offcanvas-header"
              variant="light"
              closeButton
            >
              <Offcanvas.Title>Menu</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="flex-column">
                <Nav.Link href="/admin-dashboard" className="active">
                  CUSTOMER RESTRICTION DETAIL
                </Nav.Link>
                {/* <Nav.Link href="/stock-list">STOCK LIST</Nav.Link> */}
                <Nav.Link href="/addtocartsummary">ADD TO CART SUMMARY</Nav.Link>
                <div className="d-block d-lg-none">
                  <ExhibitionDropdown />
                </div>
              </Nav>
            </Offcanvas.Body>
          </Offcanvas>
        </>
      }


      <>{children}</>

      {/* {footer} */}
      {/* brand logo */}




      <div align="center" style={{ fontFamily: "Roboto", marginTop: "10px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <h4
            align="center"
            style={{ fontSize: "14px", marginTop: "31px", color: "#35646E" }}
          >
            POWERED BY
          </h4>
          <div
            style={{
              width: "100px",
              height: "50px",
              borderRadius: "10px",
              overflow: "hidden",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "5px",
            }}
          >
            <img
              src={brandLogo}
              alt="Brandlogo"
              style={{
                width: "100%",
                height: "100%",
                backgroundSize: "cover",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;
